import { Car } from "lucide-react";

const CAR_IMG = "https://images.unsplash.com/photo-1769641241150-26c44a98e17a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const googleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const GoogleButton = ({ label = "Continuer avec Google" }) => (
  <button
    type="button"
    onClick={googleLogin}
    data-testid="google-login-button"
    className="flex w-full items-center justify-center gap-3 rounded-lg border border-white/15 bg-white/5 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-white/10"
  >
    <svg className="h-5 w-5" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47a5.53 5.53 0 0 1-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A11.99 11.99 0 0 0 12 24z" />
      <path fill="#FBBC05" d="M5.27 14.29A7.2 7.2 0 0 1 4.89 12c0-.8.14-1.57.38-2.29V6.62H1.29a12 12 0 0 0 0 10.76l3.98-3.09z" />
      <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42A11.98 11.98 0 0 0 12 0 11.99 11.99 0 0 0 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
    </svg>
    {label}
  </button>
);

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#05070B] text-white">
      <img src={CAR_IMG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-br from-[#05070B] via-[#05070B]/85 to-[#05070B]/50" />
      <div className="pointer-events-none absolute -left-32 top-1/3 h-96 w-96 rounded-full bg-cyan-500/10 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 bottom-0 h-80 w-80 rounded-full bg-cyan-400/10 blur-3xl" />

      <div className="relative z-10 mx-auto grid min-h-screen max-w-6xl items-center gap-12 px-6 py-10 lg:grid-cols-2">
        <div className="hidden lg:block animate-fade-up">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-cyan-400/30 bg-cyan-500/10">
              <Car className="h-6 w-6 text-cyan-400" />
            </div>
            <div>
              <p className="font-heading text-2xl font-bold tracking-tight">Sylla Auto Good</p>
              <p className="text-xs uppercase tracking-[0.25em] text-cyan-400/80">Cockpit Automobile</p>
            </div>
          </div>
          <h1 className="font-heading mt-10 text-4xl font-bold leading-tight xl:text-5xl">
            Pilotez votre parc automobile
            <span className="text-cyan-400"> en temps réel.</span>
          </h1>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-slate-400">
            Vente, location, importation, douane, entretien et comptabilité analytique —
            chaque véhicule a son coût de revient réel, chaque franc est tracé.
          </p>
          <div className="mt-10 flex gap-8 border-t border-white/10 pt-8">
            {[["Coût de revient", "calculé en direct"], ["Alertes", "échéances & douane"], ["PDF", "factures & contrats"]].map(([a, b]) => (
              <div key={a}>
                <p className="font-heading text-sm font-bold text-cyan-300">{a}</p>
                <p className="text-xs text-slate-500">{b}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="animate-fade-up mx-auto w-full max-w-md" style={{ animationDelay: "0.15s" }}>
          <div className="mb-8 flex items-center gap-3 lg:hidden">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-cyan-400/30 bg-cyan-500/10">
              <Car className="h-6 w-6 text-cyan-400" />
            </div>
            <p className="font-heading text-xl font-bold">Sylla Auto Good</p>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-8 shadow-2xl shadow-black/50 backdrop-blur-xl">
            <h2 className="font-heading text-2xl font-bold">{title}</h2>
            <p className="mt-1 text-sm text-slate-400">{subtitle}</p>
            <div className="mt-7">{children}</div>
          </div>
          {footer && <div className="mt-5 text-center text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export const darkInput =
  "mt-1.5 bg-white/5 border-white/10 text-white placeholder:text-slate-500 focus-visible:border-cyan-400 focus-visible:ring-cyan-400/30";

export const darkLabel = "text-xs font-medium uppercase tracking-wider text-slate-400";
